let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6KSkd")).then(() => parcelRequire('fsKGx'));